import * as React from 'react';
import classnames from 'classnames';
import { AnalyticsContext, AnalyticsLocationConsumer, trackEvent } from 'latitude-analytics';
import SvgInline from '@latitude/svg-inline';
import './_logon-button.scss';
// Use ref forwarding to obtain a ref to the <button> element
// https://reactjs.org/docs/forwarding-refs.html
const LogonButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const [analytics] = React.useContext(AnalyticsContext);
  const {
    active,
    children,
    className,
    mobileVisible,
    onClick,
    label
  } = props;
  const handleTracking = (event, analytics, location) => {
    onClick(); // toggles login form visibility

    if (trackEvent) {
      trackEvent(analytics, {
        category: 'log in',
        action: 'interaction',
        label: 'log in',
        location
      });
    }
  };
  return /*#__PURE__*/React.createElement(AnalyticsLocationConsumer, null, location => /*#__PURE__*/React.createElement("div", {
    className: "logon-button-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    ref: ref,
    className: classnames('logon-button', className, {
      'mobile-visible': mobileVisible,
      'is-active': active
    }),
    type: "button",
    "aria-label": "Log in",
    onClick: event => handleTracking(event, analytics, location)
  }, /*#__PURE__*/React.createElement(SvgInline, {
    className: "profile-icon",
    name: "person"
  }), /*#__PURE__*/React.createElement("div", {
    className: "logon-button__label"
  }, label || 'Log in'), /*#__PURE__*/React.createElement(SvgInline, {
    "aria-label": "Down",
    name: active ? 'chevron-up' : 'chevron-down',
    className: "up-down-icon"
  })), children));
});
export default LogonButton;